<mat-calendar #calendar [(selected)]="selectedDate" [minDate]="min" [maxDate]="max" [dateFilter]="filters"
    [dateClass]="dateClass" (selectedChange)="dateChanged($event!)" [startAt]="activeMonth ? activeMonth : selectedDate">
</mat-calendar>

<div class="flex flex-col gap-3 py-4 px-1 w-full">
    <div class="flex flex-wrap w-full">
        <!-- serie 1 -->
        <div class="flex gap-2 items-center text-xs w-full xxs:w-5/12">
            <div [class]="iconSerie1 ? cssSerie1 + ' flex items-center justify-center'  : cssSerie1 + ' h-4 w-4'">
                <mg-icon  *ngIf="iconSerie1" class="w-fit h-fit m-1" iconClass="opacity-25 text-lg" [iconName]="iconSerie1"></mg-icon>
            </div>{{titleSerie1}}
        </div>
        <!-- serie 2 -->
        <div class="flex gap-2 items-center text-xs w-full xxs:w-5/12">
            <div [class]="iconSerie2 ? cssSerie2 + ' flex items-center justify-center'  : cssSerie2 + ' h-4 w-4'">
                <mg-icon  *ngIf="iconSerie2" class="w-fit h-fit m-1" iconClass="opacity-25 text-lg" [iconName]="iconSerie2"></mg-icon>
            </div>{{titleSerie2}}
        </div>
    </div>
    <div class="flex flex-wrap">
        <!-- serie 3 -->
        <div class="flex gap-2 items-center text-xs w-full xxs:w-5/12">
            <div [class]="iconSerie3 ? cssSerie3 + ' flex items-center justify-center'  : cssSerie3 + ' h-4 w-4'">
                <mg-icon  *ngIf="iconSerie3" class="w-fit h-fit m-1" iconClass="opacity-25 text-lg" [iconName]="iconSerie3"></mg-icon>
            </div>{{titleSerie3}}
        </div>
        <!-- serie 4 -->
        <div class="flex gap-2 items-center text-xs w-full xxs:w-5/12">
            <div [class]="iconSerie4 ? cssSerie4 + ' flex items-center justify-center'  : cssSerie4 + ' h-4 w-4'">
                <mg-icon  *ngIf="iconSerie4" class="w-fit h-fit m-1" iconClass="opacity-25 text-lg" [iconName]="iconSerie4"></mg-icon>
            </div>{{titleSerie4}}
        </div>
    </div>

    <div class="flex flex-wrap">
        <!-- serie 5 -->
        <div class="flex gap-2 items-center text-xs w-full xxs:w-5/12">
            <div [class]="iconSerie5 ? cssSerie5 + ' flex items-center justify-center'  : cssSerie5 + ' h-4 w-4'">
                <mg-icon  *ngIf="iconSerie5" class="w-fit h-fit m-1" iconClass="opacity-25 text-lg" [iconName]="iconSerie5"></mg-icon>
            </div>{{titleSerie5}}
        </div>
    </div>
</div>